//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React                          from 'react';
import { Link as ReactRouterDomLink } from 'react-router-dom';
import classNames                     from 'classnames';
import ComponentHelper                from '@/helper/ComponentHelper';
import PropTypes                      from '@/components/PropTypes';
import styles                         from './styles.module.scss';
import LogoAsset                      from '../../../../assets/images/foundry.png';

export class Component extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            nextProps,
            nextState,
        );
    }

    render() {
        const className = classNames(
            styles.foundryLogo,
            this.props.className,
        );

        const logoImage = (
            <img
                src={LogoAsset}
                alt="Foundry"
                className={styles.foundryLogoImage}
            />
        );

        return (
            <div className={className}>
                {logoImage}
            </div>
        );
    }
}

export const FoundryLogo = Component;

Component.propTypes = {
    className: PropTypes.string,
    to:        PropTypes.to,
};

Component.defaultProps = {
    className: null,
    to:        null,
};

Component.renderAffectingProps = Object.keys(Component.defaultProps);

Component.renderAffectingStates = [];

export default Component;
